// extracted by mini-css-extract-plugin
export var deleteIcon = "_sq-5";
export var deleteOption = "_sq-3";
export var divider = "_sq-2";
export var downloadIcon = "_sq-4";
export var drawer = "_sq-0";
export var drawerFooter = "_sq-6";
export var drawerOpen = "_sq-1";
export var highlighted = "_sq-7";
export var lighterHighlight = "_sq-8";